<template lang="pug">
    button(
        :disabled="loading"
        @click="onClick"
        class="bg-gray-300 p-2 rounded-full text-sm h-10 custom-button inline-flex items-center justify-center gap-2"
        :class="[getButtonColor(), { 'opacity-80 cursor-wait': loading }]"
    )
        span.app-button-spinner(v-if="loading" aria-hidden="true")
        slot
</template>

<script>
//Store
import { RootGetterTypes } from '@/store/types';

export default {
    name: "Button",
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        SETTINGS() {
            return this.$store.getters[`${RootGetterTypes.GetSettings}`]
        },
    },
    methods: {
        getButtonColor() {
            return this.SETTINGS.button_color
        },
        onClick(event) {
            if (this.loading) {
                event.preventDefault()
                return
            }
            this.$emit('click')
        },
    }
}
</script>

<style scoped>
.app-button-spinner {
    width: 14px;
    height: 14px;
    border: 2px solid currentColor;
    border-top-color: transparent;
    border-radius: 50%;
    animation: app-button-spin 0.7s linear infinite;
    flex-shrink: 0;
}

@keyframes app-button-spin {
    to {
        transform: rotate(360deg);
    }
}
</style>